import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import AdminOptionsNavigator from "../../../navigation/AdminOptionsNavigator";
import styles from "./adminOptions.module.css";

const AdminOptions = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("admin-options", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/admin-options/${tab.path}`}>
                {tab.label}
              </PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>

      <AdminOptionsNavigator />
    </div>
  );
};

export default AdminOptions;
